import { ACTIONS } from '../../modules/constants';

const SET_DRIVER_LICENSE_ID_FEE = 'fcr/otf/SET_DRIVER_LICENSE_ID_FEE';
const SET_PROPERTY_TAX_FEE = 'fcr/otf/SET_PROPERTY_TAX_FEE';
const SET_HUNTING_FISHING_FEE = 'fcr/otf/SET_HUNTING_FISHING_FEE';

const INITIAL_STATE = {
  driversLicenseIdFee: '0.00',
  propertyTaxFee: '0.00',
  huntingAndFishingFee: '0.00',
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case ACTIONS.RESET:
    case ACTIONS.RESET_OTHER_TRANSACTION_FEES:
      return {
        ...INITIAL_STATE,
      };
    case SET_DRIVER_LICENSE_ID_FEE:
      return {
        ...state,
        driversLicenseIdFee: action.fee,
      };
    case SET_PROPERTY_TAX_FEE:
      return {
        ...state,
        propertyTaxFee: action.fee,
      };    
    case SET_HUNTING_FISHING_FEE:
      return {
        ...state,
        huntingAndFishingFee: action.fee,
      };
    default:
      return state;
  }
}

export function setDriverLicenseIdFee(fee) {
  return {
    type: SET_DRIVER_LICENSE_ID_FEE,
    fee,
  };
}

export function setPropertyTaxFee(fee) {
  return {
    type: SET_PROPERTY_TAX_FEE,
    fee,
  };
}

export function setHuntingFishingFee(fee) {
  return {
    type: SET_HUNTING_FISHING_FEE,
    fee,
  };
}
